<template>
  <svg :width="width" :height="height" viewBox="0 0 10 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 59.1 (86144) - https://sketch.com -->
      <title>Path 2</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="caretDown" :transform="`rotate(${rotate}, 5, 2)`" :stroke="color">
              <polyline id="Path-2" points="0 0 5 5 10 0"></polyline>
          </g>
      </g>
  </svg>
</template>

<script>
export default {
  name: 'CaretDown',

  props: {
    color: {
      type: String,
      default: '#5c5e62'
    },
    height: {
      type: String,
      default: '10px'
    },
    width: {
      type: String,
      default: '8px'
    },
    rotate: {
      type: String,
      default: '0'
    }
  }
}
</script>
<style lang="scss" scoped>
#caretDown {
  transition: transform .3s;
}
</style>
